import * as stylex from "@stylexjs/stylex";
import { useRTL } from "../../../../hooks";
import { colors } from "../../../../materials/consts.stylex";
import { typography } from "../../../../materials/typography.stylex";
const stylexStyles = {
    label: {
        kMwMTN: "x196nufh",
        k1xSpc: "x78zum5",
        kGNEyG: "x1pha0wt",
        kOIVth: "x1jnr06f",
        $$css: true
    },
    labelLtr: {
        kXwgrk: "x1q0g3np",
        kjj79g: "x1nhvcw1",
        $$css: true
    },
    labelRtl: {
        kXwgrk: "x15zctf7",
        kjj79g: "x13a6bvl",
        $$css: true
    }
};
function Legend({ series, lineStyle, orientation = "vertical", formatLegendLabel = (value)=>value.toString() }) {
    const isRTL = useRTL();
    return <div {...{
        0: {
            className: "xyorhqc x78zum5 x1a02dak x167g77z xdt5ytf"
        },
        1: {
            className: "xyorhqc x78zum5 x1a02dak x167g77z x1q0g3np"
        }
    }[!!(orientation === "horizontal") << 0]}>
      {series.map((value)=>{
        return <div key={value} {...stylex.props(typography.meta, stylexStyles.label, isRTL ? stylexStyles.labelRtl : stylexStyles.labelLtr)}>
            <div className="x1xc55vz xdk7pt x16rqkct x20nx6h" style={{
            backgroundColor: lineStyle(value).stroke
        }}/>
            {formatLegendLabel(value)}
          </div>;
    })}
    </div>;
}
export default Legend;
